// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e9d07d1","453":"1f468254","667":"53f5eff9","977":"abcde9e9"}[chunkId] + ".chunk.js";
};